// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-3KXbyRYM clearfix","list":"list-2wnTLIzx"};